import { apiRequest } from "./client";
import { getAxiosBaseUrl } from "./axios";

// BLOCK 2 · Acquisition API client.
// STATUS: STATIC_PASS. Runtime verification pending staging deploy.
// NOTE: mutations intentionally use normal API errors; funnel UI handles them without losing local progress.

function eventUrl() {
  const base = String(getAxiosBaseUrl() || "").replace(/\/+$/, "");
  if (!base) return "/api/acquisition/event";
  if (/\/api$/i.test(base)) return `${base}/acquisition/event`;
  return `${base}/api/acquisition/event`;
}

export const acquisitionApi = {
  publicStats() {
    return apiRequest("/acquisition/public-stats");
  },
  startSession(payload) {
    return apiRequest("/acquisition/session", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  updateSession(sessionId, payload) {
    return apiRequest(`/acquisition/session/${encodeURIComponent(sessionId)}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },
  track(payload) {
    return apiRequest("/acquisition/event", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  trackKeepalive(payload) {
    if (typeof window === "undefined" || typeof fetch !== "function") return Promise.resolve();
    return fetch(eventUrl(), {
      method: "POST",
      credentials: "include",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch(() => null);
  },
  adminAnalytics(params = {}) {
    return apiRequest("/admin/acquisition/analytics", { params });
  },
  adminProspects(params = {}) {
    return apiRequest("/admin/acquisition/prospects", { params });
  },
};
